/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Attributes_Clipboard_Missing_ErrorInputs */



/**
* | output |
* | --- |
* | "Clipboard does not contain Event Info" |
*
* @param {Paste_Attributes_Clipboard_Missing_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const paste_attributes_clipboard_missing_error = /** @type {((inputs?: Paste_Attributes_Clipboard_Missing_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Attributes_Clipboard_Missing_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le presse-papiers ne contient pas d'informations d'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Zwischenablage enthält keine Ereignisinformationen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gli appunti non contengono informazioni sull'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Буфер обмена не содержит информации о событии.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El portapapeles no contiene información del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("剪贴板不包含事件信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クリップボードにイベント情報が含まれていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लिपबोर्ड में इवेंट की जानकारी नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A área de transferência não contém informações sobre o evento.")
	return /** @type {LocalizedString} */ ("Clipboard does not contain Event Info")
});